import React from "react";
import PropTypes from "prop-types";
import { VFinder } from "../components/VacationFinder";

const VacationFinder = ({ pageContext }) => {
	const locale = pageContext?.locale;
	const language = locale && locale.split("-")[0];

	/* Setup the app config settings */
	const vfConfig = {
		options: {
			trackingID: "vacation-finder-app",
			alias: {
				desktop: "vmt",
				mobile: "vma",
			},
			videoDemo: false,
		},
	};

	return <VFinder language={language} config={vfConfig} />;
};

VacationFinder.propTypes = {
	pageContext: PropTypes.object.isRequired,
};

VFinder.defaultProps = {
	language: "en",
};

export default VacationFinder;
